import React from 'react';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
    dataContainer: {
        padding: '4rem 1rem 1rem 0rem',
        maxWidth: '40rem'        
    },
    body1: {
        
    },
    label: {
        fontWeight: 800,
        color: theme.palette.primary.main,
        marginTop: '.25rem',
        display: 'inline-block' 
    },
    researchHeading: {
        fontWeight: 800,
        color: '#f00'
    },
    factSheet: {
        color: theme.palette.tertiary.main,
    },
    subCat: {
        marginLeft: '1rem',
    },
    monospace: {
        
        marginLeft: '.5rem'
    },
    populationOrigins: {
        marginTop: '1rem',
        marginBottom: '.5rem'
    },
    population: {
        marginLeft: '1.5rem',
        marginTop: '.5rem',
        fontFamily: 'monospace',
    },
    smMap: {
        float: 'right',
        margin: '1.5rem 0 1.5rem 1.5rem'
    }
}));


export default function GilaRiverData() {
    const classes = useStyles();

    return (
        <div className={classes.dataContainer}>
            <Typography variant='h3' className={classes.researchHeading}>
                Research: Gila River Relocation Camp</Typography>
            <Typography variant='body1' className={classes.factSheet}>
                <p><span className={classes.label}>Location:</span> 45 miles southeast of Phoenix, in Pinal County, Arizona, near Sacaton. The Superstition Mountains loom in the distance.</p>

                <img src={`usmap.sm.gif`} className={classes.smMap} alt="small map of Japanese-American internment camps in western USA" />

                <p><span className={classes.label}>Size:</span> 17,000 acres; the center was divided into two camps: Canal (209.5 acres) and Butte (789.25 acres).</p>

                <p><span className={classes.label}>Peak population:</span> 13,348</p>

                <p><span className={classes.label}>Date of peak: </span> December 30, 1942</p>
                <p><span className={classes.label}>Opening date: </span> July 20, 1942</p>

                <p><span className={classes.label}>Closing Dates: </span></p>
                <p className={classes.subCat}><span className={classes.label}>Canal Camp:</span> September 28, 1945</p>
                <p><span className={classes.subCat}><span className={classes.label}>Butte Camp: </span> November 10, 1945</span></p>

                <p><span className={classes.label}>Climate: </span> Desert: summer temperatures reached 125 degrees. The average daily high temperatures for July, August, and September 1942 were 109.6, 104.0, and 99.7 degrees, respectively. Though not as bad as some other camps, duststorms were also a problem here.</p>

                <p className={classes.populationOrigins}><span className={classes.label}>Population Origins: </span>

                    <p className={classes.subCat}>Of the 10,814 Americans held prisoner here...</p>

                    <p className={classes.population}>
                                                4,952 prisoners were from Los Angeles, CA
                        <br />1,972 were from Fresno, CA
                        <br />1,797 were from Santa Barbara, CA
                        <br />815 were from San Joaquin, CA
                        <br />695 were from Contra Costa and Ventura Counties, CA
                    </p>

                    <p><span className={classes.label}>Via "Assembly Centers": </span> Most came via Turlock (3,566), Tulare (4,951), and Santa Anita (1,294) "Assembly Centers"; nearly 3,000 came directly to Gila and another 2,000 came from Jerome upon its closing.</p>

                    <p>The population was a roughly equal split between rural and urban peoples.</p>
                </p>

                <p><span className={classes.label}>Project director(s):</span> Lewis J. Jorn, Eastburn Smith, Robert B. Cozzens, L.H. Bennett, and Douglas M.Todd.</p>

                <p><span className={classes.label}>Community Analysts: </span> James H. Barnett and G.Gordon Brown.</p>

                <p><span className={classes.label}>Newpaper(s): </span> <em>Gila News Courier</em> (September 12, 1942 - September 5, 1945), Gila Bulletin (September 8 - 25, 1945).</p>

                <p><span className={classes.label}>% who answered question 28 of the loyalty questionnaire positively: </span> 90.5%</p>

                <p><span className={classes.label}>Number and percentage of eligible citizen males inducted directly into ARMED FORCES: </span> 487 (5.0%)</p>

                <p><span className={classes.label}>Industry: </span> A camouflage net factory operated from Fall 1942, to May 1943; a model warship factory produced 800 models for the navy.</p>
                <p><span className={classes.label}>History: </span> Gila River was on Pima Indian Reservation land. The WRA director Milton Eisenhower refused to relinquish administrative control of the camp to the Office of Indian Affairs, probably because of the potential for profitable agricultural enterprise here. Much of the administration staff at Gila came from OIA personnel.</p>

                <p>Gila had the most extensive agricultural program of all the camps. At its peak, Gila farmed approximately 7,000 acres, 3,000 in vegetable crops, some of which were shipped to other camps. Gila had 2,000 head of cattle, 2,500 hogs, 25,000 chickens, and 110 dairy cows. Fields of stocks and marigolds were also grown here for center consumption.</p>

                <p>Gila saw four project directors in its first eight months. The fourth, LH Bennett, remained director from December 12, 1942 to July 31, 1945.</p>

                <p>The camp was marred by inadequate housing, as people poured into a center which was not yet complete. As a result, Americans were housed in every conceivable space, in nearly constant 100 degree temperatures, until construction could be completed. Schools opened in October 1942 despite the almost total lack of supplies and furniture.</p>

                <p>On November 30, 1942, Takeo Tada was beaten by a group of men. He had been employed by both the Turlock "Assembly Center" and Gila administrations and was targeted as an "inu" (dog) by those angry over a delay in clothing allocations and at the administration in general. Hearings resulted in a 30 day jail sentance for the admitted perpetrator, amid a tense atmosphere where much of the camp population supported the attacker.</p>

                <p>Inadequate sanitation and sewage facilities coupled with the wind, dust, and heat, led to outbreaks of diarrhea, tuberculosis, "Valley Fever", and other less serious disorders.</p>

                <p>When Eleanor Roosevelt was to visit one of the camps in the Spring of 1943, Gila was the one chosen, undoubtably because it had the best appearance.</p>

                <p><span className={classes.label}>Source: </span> <em>Japanese American History: An A to Z Reference, 1868 to the Present</em>, by Brian Niiya. New York: Facts on File, 1993. This information is provided with the permission from the Japanese American National Museum and Brian Niiya, 1997.</p>

            </Typography>
        </div>
    );
} 